import { Id, TextField } from "@dgs/core";
import { TFunction } from "i18next";
import { ReactNode } from "react";
import { ContactAnchor } from "../../ui/ContactMeans";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

interface PrimaryPhoneValue {
	id: Id;
	phoneNumber: string;
	type: string;
}

export function createPrimaryPhoneContactAttributeBaseHandler(id: Id): IContactAttributeBaseHandler {
	return {
		type: "PRIMARY_PHONE",
		id,
		getLabel: (t) => t("Phone"),
	};
}

export function createPrimaryPhoneContactAttributeProfileHandler(
	id: Id,
	value: PrimaryPhoneValue | null,
): IContactAttributeHandler<PrimaryPhoneValue | null> {
	const baseHandler = createPrimaryPhoneContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			if (!value) return "-";
			return <ContactAnchor type="tel">{value.phoneNumber}</ContactAnchor>;
		},
		renderFormField(t: TFunction, prefix): ReactNode {
			return (
				<TextField
					type="tel"
					name={`${prefix ? `${prefix}.` : ""}${id}.value.phoneNumber`}
					label={baseHandler.getLabel(t)}
				/>
			);
		},
		toRequestValue(): ContactAttributeRequest<PrimaryPhoneValue | null> {
			return { id, value: this.value?.phoneNumber === null ? null : this.value };
		},
	};
}

export function createPrimaryPhoneContactAttributeListHandler(id: Id): IContactAttributeListHandler {
	const baseHandler = createPrimaryPhoneContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		getColumnSize: () => "1fr",
	};
}
